import { type GridColDef } from '@mui/x-data-grid';

export const orderColumns = (
  columns: GridColDef[],
  columnOrderModel: string[],
  disableColumnReorder?: boolean,
) => {
  if (disableColumnReorder) {
    return columns;
  }

  if (!columnOrderModel || columnOrderModel.length === 0) {
    return columns;
  }

  const columnFields = new Set(columns.map((column) => column.field));
  const orderMap = new Map(
    // Keep user order for known fields and ignore stale/unknown ones.
    // This prevents a full fallback to default order when columns are added/removed. as it was before for some reason.
    columnOrderModel
      .filter((field) => columnFields.has(field))
      .map((field: string, index: number) => [field, index]),
  );

  const indexedColumns = columns.map((column, defaultIndex) => ({
    index: orderMap.get(column.field) ?? columns.length + defaultIndex,
    ...column,
  }));

  return indexedColumns.sort((a, b) => a.index - b.index);
};
